import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const LifeInsuranceQuotesWrapper = ({
  inventoryType,
  title,
  buttonText,
  pricingCode,
  fetchQuotesOnLoad,
  zipCode,
  disableGeolocation,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'LifeInsuranceQuotes',
        version: '1.0.0',
        props: {
          inventoryType,
          title,
          buttonText,
          pricingCode,
          fetchQuotesOnLoad,
          zipCode,
          disableGeolocation,
        },
      }}
    </StructuredContent>
  );
};

LifeInsuranceQuotesWrapper.propTypes = {
  title: PropTypes.string,
  buttonText: PropTypes.string,
  pricingCode: PropTypes.string,
  fetchQuotesOnLoad: PropTypes.bool,
  zipCode: PropTypes.string,
  inventoryType: PropTypes.string,
  disableGeolocation: PropTypes.bool,
};

LifeInsuranceQuotesWrapper.defaultProps = {
  title: 'Compare life insurance',
  buttonText: 'VIEW MY POLICIES',
  pricingCode: '668365',
  fetchQuotesOnLoad: true,
  zipCode: '',
  inventoryType: 'nw-standalone',
  disableGeolocation: false,
};

LifeInsuranceQuotesWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('title', 'Title'),
    stringInputSpec('buttonText', 'Button Text'),
    stringInputSpec('pricingCode', 'Pricing Code'),
    stringInputSpec('zipCode', 'Zip Code'),
    stringInputSpec('inventoryType', 'Inventory Type'),
    boolCheckboxSpec('fetchQuotesOnLoad', 'Fetch Quotes on Load'),
    boolCheckboxSpec('disableGeolocation', 'Disable Geolocation'),
  ];
};

LifeInsuranceQuotesWrapper.displayName = 'LifeInsuranceQuotesWrapper';

export default LifeInsuranceQuotesWrapper;
